<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
            <userLeft :active="8" />
            <div class="box5">
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">增加发票信息</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 收票方式</div>
                    <div class="item_title" style="text-align: left; margin-left: 20px;">纸质发票</div>
                    <div style="float: right; color: #2B9A34;">
                        <span>收起</span>
                        <a-icon type="up" />
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 姓名</div>
                    <a-input placeholder="请输入收票人姓名" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 手机号码</div>
                    <a-input placeholder="请输入收票人手机号码" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 收票地址</div>
                    <a-input placeholder="请输入收票地址" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span></div>
                    <a-checkbox style="margin-left: 20px;">
                        设为默认
                    </a-checkbox>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span></div>
                    <div class="submit_but" style="margin-left: 20px; float: left;">提交</div>
                </div>

                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 收票方式</div>
                    <div class="item_title" style="text-align: left; margin-left: 20px; width: 30%;">电子发票（仅支持增值税普通发票）</div>
                    <div style="float: right; color: #2B9A34;">
                        <span>收起</span>
                        <a-icon type="up" />
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 姓名</div>
                    <a-input placeholder="请输入收票人姓名" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 手机号码</div>
                    <a-input placeholder="请输入收票人手机号码" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span></div>
                    <a-checkbox style="margin-left: 20px;">
                        设为默认
                    </a-checkbox>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span></div>
                    <div class="submit_but" style="margin-left: 20px; float: left;">提交</div>
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {};
    },
    methods: {},
    created() {}
};
</script>

<style scoped>
.submit_but {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    margin: 4% auto;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
}
.xuxian {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e8e6e6;
    margin-top: 2%;
}
.item_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 42px;
    text-align: right;
    float: left;
    margin-top: 5px;
    width: 20%;
}
.box14 {
    width: 120px;
    height: 32px;
    border: 1px solid #2c9a34;
    float: right;
    text-align: center;
    line-height: 32px;

    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
}
.box13 {
    width: 16.6666%;
    height: 100%;
    float: left;

    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}
.box12 {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
    margin-top: 4%;
}
.box11 {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    margin: 8% auto;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
}

.box10 {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ff9629;
    /* line-height: 16px; */
    margin: 4% auto;
}

.box9 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin: auto;
}

.box8 {
    width: 100%;
    height: 105px;
    background: EEF7EF;
    /* opacity: 0.08; */
    padding-top: 4%;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 1023px;
    width: 80%;
    /* min-height: 1023px; */
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
    min-height: 1023px;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/add_ticket_info.vue